import React, { useState, useContext, useEffect } from "react";

import { UserContext } from "./UserContext";
import {
  collection,
  doc,
  getDoc,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../services/firebaseConfig";

export const DataContext = React.createContext();

export const DataStorage = ({ children }) => {
  const { userData } = useContext(UserContext);
  const [activitiesList, setActivitiesList] = useState({
    mind: [],
    move: [],
    nutri: [],
    values: [],
  });
  const [mindList, setMindList] = useState([]);
  const [moveList, setMoveList] = useState([]);
  const [nutriList, setNutriList] = useState([]);
  const [valuesList, setValuesList] = useState([]);
  const [step, setStep] = useState(0);
  const [appointmentsDay, setAppointmentsDay] = useState([]);
  const [waitingList, setWaitingList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState([]);
  const [proSelected, setProSelected] = useState();
  const [showAppointmentModal, setShowAppointmentModal] = React.useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [view, setView] = useState("day");
  const [loadingData, setLoadingData] = useState(null);
  const [meetingsList, setMeetingsList] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function loadActivities() {
      try {
        setLoadingData(true);
        const mapping = [
          { key: "mind", id: "mindActsList", arrayKey: "mindActsList" },
          { key: "move", id: "moveActsList", arrayKey: "moveActsList" },
          { key: "nutri", id: "nutriActsList", arrayKey: "nutriActsList" },
          { key: "values", id: "valuesActsList", arrayKey: "valuesActsList" },
        ];
        const out = { mind: [], move: [], nutri: [], values: [] };
        await Promise.all(
          mapping.map(async (m) => {
            const snap = await getDoc(doc(db, "activities", m.id));
            if (snap.exists()) {
              const data = snap.data();
              const arr = data?.[m.arrayKey] || [];
              out[m.key] = Array.isArray(arr) ? arr.slice(0, 200) : [];
            }
          })
        );
        if (mounted)
          setActivitiesList(out) && console.log("Atividades carregadas");
        setMindList(out.mind);
        setMoveList(out.move);
        setNutriList(out.nutri);
        setValuesList(out.values);
      } catch (err) {
        console.error("Erro carregando activities:", err);
      } finally {
        if (mounted) setLoadingData(false);
      }
    }
    loadActivities();

    // subscribe to upcoming meetings where user is participant (live)
    if (userData && userData.email) {
      const q = query(
        collection(db, "meetings"),
        where("participants", "array-contains", userData?.email),
        where("status", "==", "scheduled"),
        // where("scheduleFor", ">=", Timestamp.fromDate(new Date())),
        orderBy("scheduleFor", "asc"),
        limit(10)
      );

      const unsubscribe = onSnapshot(
        q,
        (snap) => {
          if (!mounted) return;
          const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
          setMeetingsList(docs);
          setLoadingData(false);
        },
        (err) => {
          console.error("Erro no snapshot meetings:", err);
          if (mounted) setError("Erro ao carregar reuniões.");
          setLoadingData(false);
        }
      );
      return () => {
        mounted = false;
        unsubscribe && unsubscribe();
      };
    }
  }, [userData]);

  return (
    <DataContext.Provider
      value={{
        activitiesList,
        setActivitiesList,
        meetingsList,
        setMeetingsList,
        mindList,
        setMindList,
        moveList,
        setMoveList,
        nutriList,
        setNutriList,
        valuesList,
        setValuesList,
        step,
        setStep,
        appointmentsDay,
        setAppointmentsDay,
        waitingList,
        setWaitingList,
        selectedPatient,
        setSelectedPatient,
        proSelected,
        setProSelected,
        showAppointmentModal,
        setShowAppointmentModal,
        selectedAppointment,
        setSelectedAppointment,
        view,
        setView,
        loadingData,
        setLoadingData,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
